import r from"./_arrayPush.js";import o from"./_getPrototype.js";import t from"./_getSymbols.js";import m from"./stubArray.js";var e=Object.getOwnPropertySymbols?function(m){for(var e=[];m;)r(e,t(m)),m=o(m);return e}:m;export{e as default};
//# sourceMappingURL=_getSymbolsIn.js.map
